export default __webpack_public_path__ + "67f95041cf132548c5d8ba80ae6a2935.png";